import { render, staticRenderFns } from "./configuracao-perfis.vue?vue&type=template&id=ad461f2e&scoped=true"
import script from "./configuracao-perfis.vue?vue&type=script&lang=ts"
export * from "./configuracao-perfis.vue?vue&type=script&lang=ts"
import style0 from "./configuracao-perfis.vue?vue&type=style&index=0&id=ad461f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad461f2e",
  null
  
)

export default component.exports